import React from 'react';
import './MainContent.css';

export default function MainContent({ activeSection, isAnimating }) {
    return (
        <div className={`main-content fade ${activeSection && isAnimating ? 'animate-booksy' : ''}`}>
            <img
                src="/images/logo_gold.png"
                alt="Męski Lokal Logo"
                className={`home-logo ${activeSection !== 'home' ? 'logo-transparent' : ''}`}
            />

            {/* Sekcje */}
            {activeSection === 'about' && (
                <div className="content-box">
                    <h2>O NAS</h2>
                    <p>Męski Lokal to miejsce stworzone z myślą o mężczyznach,</p>
                    <p>którzy cenią sobie profesjonalizm, precyzję i dobrą atmosferę.</p>
                    <p>Oferujemy klasyczne i nowoczesne strzyżenia,</p>
                    <p>trymowanie i pielęgnacje brody oraz doradztwo w stylizacji.</p>
                </div>
            )}

            {activeSection === 'contact' && (
                <div className="content-box">
                    <h2>KONTAKT</h2>
                    <p>Adres: ul. Robotnicza 5/4, 49-300 Brzeg</p>
                    <p>Mail: meskilokal@gmail.com</p>
                </div>
            )}

            {activeSection === 'jobs' && (
                <div className="content-box">
                    <h2>PRACUJ Z NAMI</h2>
                    <p>Jeśli chcesz dołączyć do naszego zespołu wyślij CV na meskilokal@gmail.com</p>
                </div>
            )}

        </div>
    );
}
